// extracted by mini-css-extract-plugin
export default {"root":"BirthDate-root","selectYear":"BirthDate-selectYear","selectMonth":"BirthDate-selectMonth","selectDay":"BirthDate-selectDay"};